import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @StorageUnitChecks
 * @Storage Unit Checks
 * @storageUnitChecks
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"frequency","type":"text","placeholder":"Frequency","label":"Frequency","width":110,"addFormOrder":1,"editFormOrder":1,"header":"Frequency","derivedValue":"frequency=undefined","capitalizeTableText":true,"sortable":true,"id":"frequency","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"frequency","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"checkType","type":"text","placeholder":"Check Type","label":"Check Type","width":"130px","addFormOrder":6,"editFormOrder":6,"header":"Check Type","derivedValue":"checkType=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"checkType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"checkType","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facility","type":"text","placeholder":"Facility","label":"Facility","width":"130px","addFormOrder":7,"editFormOrder":7,"header":"Facility","derivedValue":"facility=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facility","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"facility","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"storageUnit","type":"text","placeholder":"Storage Unit","label":"Storage Unit","width":"130px","addFormOrder":8,"editFormOrder":8,"header":"Storage Unit","derivedValue":"storageUnit=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"storageUnit","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"address","type":"text","placeholder":"Address","label":"Address","width":"130px","addFormOrder":9,"editFormOrder":9,"header":"Address","derivedValue":"address=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"address","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"address","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"date","type":"date","placeholder":"Date","label":"Date","width":"130px","addFormOrder":10,"editFormOrder":10,"header":"Date","derivedValue":"date=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"date","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","fieldType":"Date","textAlign":"Center","show":true,"field":"date","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"storageUnitChecked","type":"text","placeholder":"Storage Unit Checked","label":"Storage Unit Checked","width":"130px","addFormOrder":11,"editFormOrder":11,"header":"Storage Unit Checked","derivedValue":"storageUnitChecked=storageUnitChecked=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnitChecked","displayinaddForm":"false","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":false,"field":"storageUnitChecked","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"status","type":"dropDown","placeholder":"Status","label":"Status","width":"130px","addFormOrder":12,"editFormOrder":12,"header":"Status","derivedValue":"status=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"status","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Checked","value":"Checked","color":"primary"},{"label":"Pending","value":"Pending","color":"warning"}],"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":true,"field":"status","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true}]
 * @[{"name":"frequency","type":"text","placeholder":"Frequency","label":"Frequency","width":110,"addFormOrder":1,"editFormOrder":1,"derivedValue":"frequency=undefined","capitalizeTableText":true,"sortable":true,"id":"frequency","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"checkType","type":"text","placeholder":"Check Type","label":"Check Type","width":"130px","addFormOrder":6,"editFormOrder":6,"derivedValue":"checkType=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"checkType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"facility","type":"text","placeholder":"Facility","label":"Facility","width":"130px","addFormOrder":7,"editFormOrder":7,"derivedValue":"facility=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"facility","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"storageUnit","type":"text","placeholder":"Storage Unit","label":"Storage Unit","width":"130px","addFormOrder":8,"editFormOrder":8,"derivedValue":"storageUnit=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"address","type":"text","placeholder":"Address","label":"Address","width":"130px","addFormOrder":9,"editFormOrder":9,"derivedValue":"address=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"address","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"date","type":"date","placeholder":"Date","label":"Date","width":"130px","addFormOrder":10,"editFormOrder":10,"derivedValue":"date=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"date","displayinaddForm":"false","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","fieldType":"Date","show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"storageUnitChecked","type":"text","placeholder":"Storage Unit Checked","label":"Storage Unit Checked","width":"130px","addFormOrder":11,"editFormOrder":11,"derivedValue":"storageUnitChecked=storageUnitChecked=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnitChecked","displayinaddForm":"false","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":false},{"name":"status","type":"dropDown","placeholder":"Status","label":"Status","width":"130px","addFormOrder":12,"editFormOrder":12,"derivedValue":"status=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"status","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Checked","value":"Checked","color":"primary"},{"label":"Pending","value":"Pending","color":"warning"}],"fieldType":"dropDown","dependent":[],"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const StorageUnitChecks = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  const [paramsObj, setParamsObj] = useState();
  const query = new URLSearchParams(location.search);
  const companyId = query.get('comapnyId');
  const params = useParams();
  useEffect(() => {
    let screenPermissions = RolePermissions.screenPermissions(
      "Storage Unit Checks"
    );
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
    if (params.id && params.id.includes('-')) {
      let arr = params.id.split('-');
      setParamsObj({
        storageUnitName: arr[0],
        name:"Maintenance",
      })
    } else {
      setParamsObj({})
    }
  }, []);

  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };
  // componentDidMount = () => {
  //   //Screen permisions value can be edit,view, no view
  //   let screenPermissions = RolePermissions.screenPermissions('Test');
  //   if (screenPermissions) {
  //     this.setState({
  //       rolePermission: screenPermissions
  //     })
  //   }
  //   // this.getRoleListFromServer()
  // }
  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [
      // {
      //   textAlign: "center",
      //   width: 47,
      //   field: "Check Box",
      //   label: "Check Box",
      //   fieldType: "multiple",
      //   header: "",
      //   selectionMode: "multiple",
      //   show: true,
      //   mobile: true,
      //   displayInSettings: true,
      // },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "frequency",
        type: "text",
        placeholder: "Frequency",
        label: "Frequency",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Frequency",
        derivedValue: "frequency=undefined",
        capitalizeTableText: true,
        sortable: true,
        id: "frequency",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "checkType",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        // style: {
        //   color: "#0e4768",
        //   cursor: "pointer",
        //   textTransform: "capitalize",
        // },
      },
      {
        name: "checkType",
        type: "text",
        placeholder: "Check Type",
        label: "Check Type",
        width: "130px",
        addFormOrder: 6,
        editFormOrder: 6,
        header: "Check Type",
        derivedValue: "checkType=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "checkType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "name",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility",
        label: "Facility",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Facility",
        derivedValue: "facilityName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "facilityName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "storageUnitName",
        type: "text",
        placeholder: "Storage Unit",
        label: "Storage Unit",
        width: "130px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Storage Unit",
        derivedValue: "storageUnitName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnitName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "storageUnitName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "address",
        type: "derivedFields",
        placeholder: "Address",
        label: "Address",
        width: "120px",
        addFormOrder: 13,
        editFormOrder: 13,
        stringType: "string",
        header: "Address",
        derivedValue: "address=street+city+state+zip",
        capitalizeTableText: false,
        sortable: true,
        isClickable: false,
        filter: true,
        actions: ["street", "city", "state", "zip"],
        actionsNumber: [],
        id: "address",
        displayinaddForm: false,
        displayineditForm: false,
        displayinregisterForm: false,
        displayinlist: "true",
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "address",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "date",
        type: "date",
        placeholder: "Date",
        label: "Date",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Date",
        derivedValue: "date=undefined",
        capitalizeTableText: false,
        sortable: false,
        actions: [],
        actionsNumber: [],
        id: "date",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        dateFormat: "MM-DD-YYYY",
        fieldType: "Date",
        textAlign: "Center",
        show: true,
        field: "created",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        show: true,
        textAlign: "center",
        width: 60,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },

    ];
    return data;
  };

  const getFormFields = () => {
    let statusTypes = [
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return [
      {
        name: "isChecked",
        type: "radio",
        placeholder: "Battery Checked",
        label: "Storage Unit Checked",
        width: "120px",
        addFormOrder: 11,
        editFormOrder: 11,
        derivedValue: "isChecked=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "isChecked",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          { label: "Yes", value: true },
          { label: "No", value: false },
        ],
        fieldType: "radio",
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
    ];
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
  };
  const getMobileTableFields = () => {
    let data = [
      {
        textAlign: "center",
        width: 47,
        field: "Check Box",
        label: "Check Box",
        fieldType: "multiple",
        header: "",
        selectionMode: "multiple",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "SNo",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "frequency",
        type: "text",
        placeholder: "Frequency",
        label: "Frequency",
        width: 110,
        addFormOrder: 1,
        editFormOrder: 1,
        header: "Frequency",
        derivedValue: "frequency=undefined",
        capitalizeTableText: true,
        sortable: true,
        id: "frequency",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "frequency",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "checkType",
        type: "text",
        placeholder: "Check Type",
        label: "Check Type",
        width: "130px",
        addFormOrder: 6,
        editFormOrder: 6,
        header: "Check Type",
        derivedValue: "checkType=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "checkType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "checkType",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "facility",
        type: "text",
        placeholder: "Facility",
        label: "Facility",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Facility",
        derivedValue: "facility=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facility",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "facility",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "storageUnit",
        type: "text",
        placeholder: "Storage Unit",
        label: "Storage Unit",
        width: "130px",
        addFormOrder: 8,
        editFormOrder: 8,
        header: "Storage Unit",
        derivedValue: "storageUnit=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnit",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "storageUnit",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "address",
        type: "text",
        placeholder: "Address",
        label: "Address",
        width: "130px",
        addFormOrder: 9,
        editFormOrder: 9,
        header: "Address",
        derivedValue: "address=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "address",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: true,
        field: "address",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "date",
        type: "date",
        placeholder: "Date",
        label: "Date",
        width: "130px",
        addFormOrder: 10,
        editFormOrder: 10,
        header: "Date",
        derivedValue: "date=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "date",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        dateFormat: "DD-MM-YYYY",
        fieldType: "Date",
        textAlign: "Center",
        show: true,
        field: "date",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "storageUnitChecked",
        type: "text",
        placeholder: "Storage Unit Checked",
        label: "Storage Unit Checked",
        width: "130px",
        addFormOrder: 11,
        editFormOrder: 11,
        header: "Storage Unit Checked",
        derivedValue: "storageUnitChecked=storageUnitChecked=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnitChecked",
        displayinaddForm: "false",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "Center",
        show: false,
        field: "storageUnitChecked",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "status",
        type: "dropDown",
        placeholder: "Status",
        label: "Status",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        header: "Status",
        derivedValue: "status=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "status",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: [
          { label: "Checked", value: "Checked", color: "primary" },
          { label: "Pending", value: "Pending", color: "warning" },
        ],
        fieldType: "dropDown",
        dependent: [],
        textAlign: "Center",
        show: true,
        field: "status",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "createdByName",
        type: "Text",
        placeholder: "Created By",
        label: "Created By",
        width: 120,
        header: "Created By",
        id: "createdByName",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: 1001,
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        field: "createdByName",
        mobile: true,
        filter: true,
        displayInSettings: true,
      },
      {
        name: "updatedByName",
        type: "Text",
        placeholder: "Updated By",
        label: "Updated By",
        width: 120,
        header: "Updated By",
        id: "updatedByName",
        displayinlist: "true",
        fieldType: "Text",
        textAlign: "Center",
        show: true,
        filter: true,
        field: "updatedByName",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "created",
        type: "date",
        placeholder: "Created",
        label: "Created",
        width: 90,
        header: "Created",
        derivedValue: "created=undefined",
        actions: [],
        actionsNumber: [],
        id: "created",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "created",
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "updated",
        type: "date",
        placeholder: "Updated",
        label: "Updated",
        width: 90,
        header: "Updated",
        derivedValue: "updated=undefined",
        actions: [],
        actionsNumber: [],
        id: "updated",
        displayinaddForm: "false",
        displayineditForm: "false",
        displayinlist: "true",
        globalSearchField: "false",
        controllerId: null,
        fieldType: "Date",
        dateFormat: "YYYY-MM-DD HH:mm:ss",
        textAlign: "Center",
        disabled: true,
        show: true,
        field: "updated",
        mobile: true,
        displayInSettings: true,
      },
    ];
    return data;
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };
  // submit1 = item => {
  //   let x = storageUnitChecksFields
  //   let objstorageUnitChecks = {}

  //   objstorageUnitChecks["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objstorageUnitChecks[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objstorageUnitChecks,
  //     newFormFields: formFields
  //   });
  // }

  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };

  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);
    // this.setState({
    //   isLoading: true
    // });
    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["storageUnitChecks"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
          // this.setState({
          //   isLoading: false
          // });
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };

  return (
    <span>
      {
        paramsObj &&
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          //
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          // globalSearch={'Display Name/Email'}
          // type='Storage Unit Checks'
          // apiUrl={apiCalls.Storage Unit Checks}
          // exportRequried={true}
          printRequried={false}
          actionsTypes={false}
          // [
          // {
          //   name: "Delete",
          //   options: [
          //     {
          //       label: "Delete",
          //       value: "Delete",
          //       show:
          //         rolePermission && rolePermission == "Edit" ? true : false,
          //       multiple: true,
          //     },
          //   ],
          // },

          // {
          //   'name': 'Block',
          //   "options": [
          //     {'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'ResetPassword',
          //   "options": [
          //     {'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
          //   ]
          // },
          // {
          //   'name': 'Submit',
          //   'action': this.submit,
          //   "options": [
          //     {'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
          //   ]
          // },
          // {
          //   name: "newModel",
          //   action: this.submit1,
          //   options: [
          //     {label: "newModel", value: "newModel", show: true, multiple: false }
          //   ]
          // }
          // ]}
          // addRequried={insertAdd}
          // editRequired={true}
          // deleteRequired={true}
          // viewRequired={true}
          settingsRequired={true}
          filterRequired={false}
          gridRequried={false}
          params={paramsObj}
          exportToCsv={false}
          refresh={true}
          getPagination={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath.storageUnitChecks}
          globalSearch={"Check Type / Facility / Storage Unit"}
          type="Storage Unit Checks"
          routeTo={apiCalls["storageUnitChecksRoute"]}
          displayViewOfForm="modal"
          sideFormLeftOrRight=""
          apiResponseKey={apiCalls["storageUnitChecks"].toLowerCase()}
          apiUrl={apiCalls["storageUnitChecks"]}
          // selectedId={params.id}
          selectionMode={true}
          companyId={companyId}

        />
      }
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="storageUnitChecks"
          apiUrl={apiCalls["storageUnitChecks"]}
        />
      ) : null}
    </span>
  );
};

export default StorageUnitChecks;
